import { useExtractMetadataFromSearchQuerySearchCardValue } from '@aibees/elephant/feature/search-list-card/hooks/use-extract-metadata-from-search-query-search-card-value';
import { LockIcon, TableCellTypography } from '@aibees/shared/components';
import {
  ParsedPreset,
  PresetVisibility,
  SearchBrowseParams,
} from '@aibees/shared/definition';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import { StarCheckbox } from '../star-checkbox';
import * as Styled from './styles';
import * as SX from './sx';
import type { SavedSearchNameProps as Props } from './types';

export const SavedSearchName = memo(
  ({ className, value, showAsLink }: Props) => {
    const { name, visibility, type, metadata } = value;
    const hookResult = useExtractMetadataFromSearchQuerySearchCardValue(
      value as ParsedPreset<SearchBrowseParams>
    );
    const hover = useBoolean(false);
    const isPrivate = visibility === PresetVisibility.PRIVATE;

    const path = showAsLink && type && metadata ? hookResult.path : '';

    const handleMouseLeave = () => {
      hover.onFalse();
    };

    const handleMouseEnter = () => {
      hover.onTrue();
    };

    return (
      <Styled.Wrapper
        className={classnames('SavedSearchName', className)}
        sx={SX.root}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Box overflow="hidden">
          {showAsLink && path ? (
            <Styled.Link to={path} target="_blank">
              <TableCellTypography
                variant="body4"
                fontWeight={500}
                color="grey.800"
                item={name}
              />
            </Styled.Link>
          ) : (
            <TableCellTypography item={name} />
          )}
        </Box>

        <Box display="flex" alignItems="center" gap={0.5}>
          {isPrivate && <LockIcon />}

          {value.favorite && <StarCheckbox item={value} />}
          {hover.value && !value.favorite && <StarCheckbox item={value} />}
        </Box>
      </Styled.Wrapper>
    );
  }
);

SavedSearchName.displayName = 'SavedSearchName';
